import { Link } from 'react-router-dom';
import { css } from '@emotion/react';

const ReactRouterLink = ({ children, ...rest }) => {
    const linkCSS = ({ linkBlue }) => css`
        font-size: 1rem;
        color: ${linkBlue};
        text-decoration: none;

        &:focus-visible {
            outline: solid;
            outline-color: ${linkBlue};
            outline-offset: 1px;
            border-radius: 2px;
            outline-width: 2px;
        }

        &:hover,
        &:focus-visible {
            text-decoration: underline;
            text-decoration-color: ${linkBlue};
        }
    `;

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Link css={linkCSS} {...rest}>
            {children}
        </Link>
    );
};

export default ReactRouterLink;
